:host {
    // --aa-alt-text-font-size: 0.7em;
    // --aa-width: 40px;
    // --aa-height: 40px;
    display: inline-block;
    width: var(--aa-width, 40px);
    height: var(--aa-height, 40px);
    border-radius: 50%;
    box-sizing: border-box;
    position: relative;
    background-color: var(--profile-background);

    * {
        box-sizing: border-box;
    }

    .border {
        width: 100%;
        height: 100%;
        display: inline-block;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        // app-avatar {
        //     span[slot="k_alt"] {
        //         font-size: var(--aa-alt-text-font-size, 0.7em);
        //     }
        // }
    }
}